module.exports = __webpack_public_path__ + "img/3-8.9c795fcf.png";